import { FC } from 'react';

import AvatarsRow from '~src/shared/avatarsRow/AvatarsRow';
import { ElementWrapper } from '~src/modules/okrs/manageObjectives/shared/shared.sc';
import RemovableItem from '~src/modules/okrs/manageObjectives/create/RemovableItem';
import { Weighting } from '~src/modules/okrs/manageObjectives/shared/Weighting';
import { LastRow } from '~src/modules/okrs/manageObjectives/edit/editListItem.sc';
import { formatKeyresultProgressable } from '~src/modules/okrs/manageObjectives/shared/utils';

import { ListElementWrapper } from './createKeyResultListElement.sc';
import { KeyResultAdd } from './CreateKeyResults';
import { Numbers } from './keyResultCreateElement.sc';

interface Props {
  keyResult: KeyResultAdd;
  deleteKeyResult: (id: string) => void;
  selectKeyResult: (keyResult: KeyResultAdd) => void;
}

export const removeAnimationTime = 300;

const CreateKeyResultListElement: FC<Props> = (props) => {
  const removeThis = () => {
    props.deleteKeyResult(props.keyResult.id);
  };

  const selectThis = () => {
    props.selectKeyResult(props.keyResult);
  };

  return (
    <ListElementWrapper>
      <RemovableItem remove={removeThis}>
        <ElementWrapper onClick={selectThis}>
          <span>{props.keyResult.name}</span>
          <Numbers>
            {formatKeyresultProgressable(parseFloat(props.keyResult.startValue))} /
            {formatKeyresultProgressable(parseFloat(props.keyResult.targetValue))}
          </Numbers>
          <LastRow>
            <AvatarsRow userData={props.keyResult.owners} />
            <Weighting weighting={props.keyResult.weighting} locked={!!props.keyResult.weighting} />
          </LastRow>
        </ElementWrapper>
      </RemovableItem>
    </ListElementWrapper>
  );
};

export default CreateKeyResultListElement;
